import MarketplaceBlock from './MarketplaceBlock';

export default MarketplaceBlock;
